'use client';
import { CopyButton } from '@sbercloud/uikit-product-copy-line';
import { Prism } from 'prism-react-renderer';
import bashLang from 'refractor/lang/bash';
import httpsLang from 'refractor/lang/http';

import s from './styles.module.scss';
bashLang(Prism);
httpsLang(Prism);

import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';
import cn from 'classnames';
import { useState } from 'react';

import { CodeBlock } from '@/components/static/HighLightCode/CodeBlock';
import { DATA_TEST_IDS_INJECTORS } from '@/constant/tests';
import { useServerDataCtx } from '@/hooks/ctx';
import { useLayoutType } from '@/hooks/useLayoutType';
import { isLoverThan } from '@/utils/layout';

import { CodeBlockProps } from './utils';

export function HighLightCode({ lang, code, withLineNumbers }: CodeBlockProps) {
  const [isVisibleCopyButton, setIsVisibleCopyButton] = useState(false);
  const { headers } = useServerDataCtx();
  const layoutType = useLayoutType(CSS_BREAKPOINTS, headers.xLayoutType);

  return (
    <div
      data-test-id={DATA_TEST_IDS_INJECTORS.highlight}
      onMouseLeave={() => setIsVisibleCopyButton(false)}
      onMouseEnter={() => setIsVisibleCopyButton(true)}
      className={s.high_light_wrapper}
    >
      <CopyButton
        className={cn(s.copy_button, {
          [s.display]: isVisibleCopyButton || isLoverThan('tablet', layoutType),
        })}
        valueToCopy={code}
      />
      <CodeBlock lang={lang} code={code} withLineNumbers={withLineNumbers} />
    </div>
  );
}
